<template>
  <div class="wrapper">
    <h1 class="title text-center mb-6 mt-10">Login as admin</h1>

    <form @submit.prevent="submit" class="form" novalidate>
      <v-text-field
        label="Email"
        solo
        class="mb-2"
        v-model="email"
        type="email"
      ></v-text-field>

      <v-text-field
        label="Password"
        solo
        v-model="password"
        class="mb-2"
        :error-messages="
          !$v.dirty && !$v.password.loginValidator
            ? 'Wrong credentials. Make sure you log in with an admin account'
            : []
        "
        type="password"
      ></v-text-field>

      <v-btn
        color="primary"
        depressed
        class="d-block mx-auto"
        type="submit"
        :loading="loader"
        :disabled="!$v.email.required || !$v.password.required"
        >Login</v-btn
      >
    </form>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import firebase from "firebase/app";
import { db } from "@/db";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

const loginValidator = function () {
  return !this.loginError;
};

export default {
  mixins: [validationMixin],
  created() {
    if (this.isLoggedIn) this.$router.push({ path: "/first" });
  },
  data() {
    return {
      email: "",
      password: "",
      loader: false,
      loginError: false,
    };
  },
  validations: {
    email: { required },
    password: { required, loginValidator },
  },
  computed: {
    ...mapState({
      isLoggedIn: (state) => state.isLoggedIn,
    }),
  },
  methods: {
    ...mapActions(["adminLogin"]),
    ...mapMutations(["setAuthState"]),
    submit() {
      this.loginError = false;
      this.$v.$touch();

      this.loader = true;

      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then((res) => {
          this.setAuthState(true);
          return db.collection("admins").doc(res.user.uid).get();
        })
        .then((res) => {
          if (!res.data()) {
            firebase.auth().signOut();
            this.setAuthState(false);
            this.loginError = true;
          }

          if (res.data().profileType != "admin") {
            firebase.auth().signOut();
            this.setAuthState(false);
            this.loginError = true;
          }

          this.loader = false;
          this.$router.push({ path: "/first" });
        })
        .catch((er) => {
          firebase.auth().signOut();
          this.setAuthState(false);
          this.loader = false;
          this.loginError = true;
        });
    },
  },
  watch: {
    password(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.loginError = false;
      }
    },
    email(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.loginError = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  width: 400px;

  @media screen and (max-width: 600px) {
    width: 100%;
  }
}
</style>